var map = {
	"./locale-provider/ar_EG.tsx": 1844,
	"./locale-provider/bg_BG.tsx": 1848,
	"./locale-provider/ca_ES.tsx": 1852,
	"./locale-provider/cs_CZ.tsx": 1856,
	"./locale-provider/de_DE.tsx": 1860,
	"./locale-provider/el_GR.tsx": 1864,
	"./locale-provider/en_GB.tsx": 1868,
	"./locale-provider/en_US.tsx": 1872,
	"./locale-provider/es_ES.tsx": 1873,
	"./locale-provider/et_EE.tsx": 1877,
	"./locale-provider/fa_IR.tsx": 1881,
	"./locale-provider/fi_FI.tsx": 1885,
	"./locale-provider/fr_BE.tsx": 1889,
	"./locale-provider/fr_FR.tsx": 1893,
	"./locale-provider/is_IS.tsx": 1897,
	"./locale-provider/it_IT.tsx": 1901,
	"./locale-provider/ja_JP.tsx": 1905,
	"./locale-provider/ko_KR.tsx": 1909,
	"./locale-provider/ku_IQ.tsx": 1913,
	"./locale-provider/nb_NO.tsx": 1917,
	"./locale-provider/nl_BE.tsx": 1921,
	"./locale-provider/nl_NL.tsx": 1925,
	"./locale-provider/pl_PL.tsx": 1929,
	"./locale-provider/pt_BR.tsx": 1933,
	"./locale-provider/pt_PT.tsx": 1937,
	"./locale-provider/ru_RU.tsx": 1941,
	"./locale-provider/sk_SK.tsx": 1945,
	"./locale-provider/sl_SI.tsx": 1949,
	"./locale-provider/sr_RS.tsx": 1952,
	"./locale-provider/sv_SE.tsx": 1956,
	"./locale-provider/th_TH.tsx": 1960,
	"./locale-provider/tr_TR.tsx": 1964,
	"./locale-provider/uk_UA.tsx": 1968,
	"./locale-provider/vi_VN.tsx": 1972,
	"./locale-provider/zh_CN.tsx": 1976,
	"./locale-provider/zh_TW.tsx": 1979
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1843;


//////////////////
// WEBPACK FOOTER
// ./components ^\.\/locale-provider\/.+_.+\.tsx$
// module id = 1843
// module chunks = 0